"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const formatErrorToBeOutputedInApphive = (error) => {
    if (error instanceof Error) {
        return error.message;
    }
    const message = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
    if ((0, ts_validators_1.valueIsString)(message)) {
        return message;
    }
    const stringifiedError = JSON.stringify(error);
    if (stringifiedError !== '{}') {
        return stringifiedError;
    }
    return 'Unknown error';
};
exports.default = formatErrorToBeOutputedInApphive;
